import { useReducer, useEffect } from "react";
import { Flex, LoadingIcon } from "basis";
import { useAccountInfo } from "library/hooks/useAccountInfo";
import { useLayout } from "library/hooks/useLayout";
import { Layout } from "../Layout/Layout";
import { CloseAccountCanClose } from "./CloseAccountCanClose";
import { CloseAccountCantClose } from "./CloseAccountCantClose";
import { CloseAccountInProgress } from "./CloseAccountInProgress";
import { CloseAccountForm } from "./CloseAccountForm";
import { CloseAccountSuccess } from "./CloseAccountSuccess";
import { CloseAccountImportantInformation } from "./CloseAccountImportantInformation";
import {
  PAGES,
  initialCloseAccountState,
  closeAccountReducer,
} from "./closeAccountReducer";

const pageInfo = {
  [PAGES.LANDING]: {
    heading: "Close account request",
  },
  [PAGES.CAN_CLOSE]: {
    heading: "Close account request",
    screenComponent: CloseAccountCanClose,
  },
  [PAGES.CANT_CLOSE]: {
    heading: "Close account request",
    screenComponent: CloseAccountCantClose,
  },
  [PAGES.IN_PROGRESS]: {
    heading: "Close account request",
    screenComponent: CloseAccountInProgress,
  },
  [PAGES.FORM]: {
    heading: "Close account request",
    screenComponent: CloseAccountForm,
  },
  [PAGES.SUCCESS]: {
    heading: "Close account request submitted",
    screenComponent: CloseAccountSuccess,
  },
};

function CloseAccountScreen({
  screenComponent: ScreenComponent,
  state,
  dispatch,
}) {
  const { scrollToTop } = useLayout();

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop, ScreenComponent]);

  return <ScreenComponent state={state} dispatch={dispatch} />;
}

function CloseAccount({ location }) {
  const { account } = location.state || {};
  const accountInfo = useAccountInfo(account);
  const [state, dispatch] = useReducer(
    closeAccountReducer,
    initialCloseAccountState,
  );
  const { page } = state;
  const { heading: pageHeading, screenComponent } = pageInfo[page];
  const showImportantInformation = [PAGES.FORM, PAGES.SUCCESS].includes(page);

  useEffect(() => {
    if (accountInfo !== null) {
      dispatch({ type: "ACCOUNT_INFO_LOADED", accountInfo });
    }
  }, [accountInfo]);

  return (
    <Layout>
      <Layout.Header>{pageHeading}</Layout.Header>
      <Layout.Main shouldRenderContent={state.accountInfo !== null}>
        {page === PAGES.LANDING ? (
          <Flex height="200" placeItems="center">
            <LoadingIcon size="medium" />
          </Flex>
        ) : (
          <CloseAccountScreen
            screenComponent={screenComponent}
            state={state}
            dispatch={dispatch}
          />
        )}
      </Layout.Main>
      {showImportantInformation && (
        <Layout.Sidebar>
          <CloseAccountImportantInformation
            canHaveRewardPoints={
              accountInfo !== null ? accountInfo.canHaveRewardPoints : false
            }
          />
        </Layout.Sidebar>
      )}
    </Layout>
  );
}

export { CloseAccount };
